export const isTeacher = role => role === 'teacher';

export const isStudent = role => role === 'student';



// WEBPACK FOOTER //
// ./src/js/utilities/permissions.js